import type { ThreadActivityPayloadMap } from "@productlane/lib/src/browser"

type AsksPost = ThreadActivityPayloadMap["linear_asks_posted"]
type MarkedDone = ThreadActivityPayloadMap["thread_marked_done"]

export function linearAsksPostedLine(post: AsksPost): string {
	const issue = post.issueIdentifier ?? "the issue"
	switch (post.kind) {
		case "created":
			return `Linear Asks posted that ${issue} was created`
		case "follow_along":
			return "Linear Asks told the customer they can follow the Ask in this thread"
		case "accepted":
			return `Linear Asks posted that ${issue} left Triage`
		case "status":
			return post.status
				? `Linear Asks posted that ${issue} moved to ${post.status}`
				: `Linear Asks posted a status change on ${issue}`
		case "duplicate":
			return post.duplicateOf
				? `Linear Asks posted that ${issue} is a duplicate of ${post.duplicateOf}`
				: `Linear Asks posted that ${issue} is a duplicate`
		case "comment": {
			const author = post.author ? `${post.author}'s comment` : "a comment"
			return post.text
				? `Linear Asks posted ${author}: ${post.text}`
				: `Linear Asks posted ${author}`
		}
		default:
			return "Linear Asks posted in Slack"
	}
}

export function linearAsksMarkedDoneLine(payload: MarkedDone): string {
	const issue = payload.issueIdentifier ?? "The issue"
	const state = payload.outcome === "canceled" ? "Canceled" : "Done"
	const told = payload.asksNotified
		? " Linear Asks told the customer in Slack."
		: ""
	return `Marked done: ${issue} is ${state} in Linear.${told}`
}
